import { render, staticRenderFns } from "./ReportProductionWorkflow.vue?vue&type=template&id=566b337a&scoped=true&"
import script from "./ReportProductionWorkflow.vue?vue&type=script&lang=js&"
export * from "./ReportProductionWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ReportProductionWorkflow.vue?vue&type=style&index=0&id=566b337a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b337a",
  null
  
)

export default component.exports